import {writable} from 'svelte/store';
import {persistStorage} from "./persistStorage";

export const persistWritable = (key, defaultValue = null) => {
  const w = writable(persistStorage.getValue(key, defaultValue));

  w.subscribe(val => persistStorage.setValue(key, val));

  return w;
};
